module.exports = __webpack_public_path__ + "assets/img/zre3.59a62a70.png";